import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceObservationTaskTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupObservationTask = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceObservationTaskTypes.ObservationTaskLookupDataType): AxiosPromise<serviceObservationTaskTypes.ObservationTaskLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.observationTask.lookupObservationTask), {
    blockSpinner,
  });
};

export const lookupObservationTaskTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceObservationTaskTypes.ObservationTaskLookupDataType): AxiosPromise<serviceObservationTaskTypes.ObservationTaskTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (value) {
    return axios.get(
      urlHelper.addQueryParameters({ search: value }, urlsConfig.observationTask.lookupObservationTask),
      {
        blockSpinner,
      },
    );
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.observationTask.lookupObservationTask), {
    blockSpinner,
  });
};

export const createObservationTask = (
  form: serviceObservationTaskTypes.ObservationTaskCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceObservationTaskTypes.ObservationTaskCreateResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.outcomeNumberId) {
    formData.append('outcomeNumberId', form.outcomeNumberId);
  }

  if (form.observationTaskNumber) {
    formData.append('observationTaskNumber', form.observationTaskNumber);
  }

  if (form.observationTaskName) {
    formData.append('observationTaskName', form.observationTaskName);
  }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.relatedAudienceProcesses) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));

    // formData.append('relatedAudienceEntities', entitiesData);
  }
  // if (form.relatedAudienceProcesses) {
  //   formData.append('relatedAudienceProcesses', processesData);
  // }

  if (form.observers) {
    form.observers.forEach((e) => formData.append('observers', e as any as string));
  }

  if (form.observerId) {
    formData.append('observerId', form.observerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.weightOfObservationInOutcome) {
    formData.append('weightOfObservationInOutcome', form.weightOfObservationInOutcome.toString());
  }

  if (form.trainingAudiencePerformance != undefined) {
    formData.append('trainingAudiencePerformance', form.trainingAudiencePerformance.toString());
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.observation) {
    formData.append('observation', form.observation);
  } else {
    formData.append('observation', '');
  }

  if (form.observationStatusId) {
    formData.append('observationStatusId', form.observationStatusId);
  }
  return axios.post(urlsConfig.observationTask.createObservationTask, formData, { blockErrorHandler: true });
};

export const observationTaskEdit = (
  form: serviceObservationTaskTypes.ObservationTaskEditDataType,
  // formData: FormData,
): AxiosPromise<serviceObservationTaskTypes.ObservationTaskEditResultType> => {
  const entitiesData = fileHelper.convertArrayData(form.relatedAudienceEntities);
  const processesData = fileHelper.convertArrayData(form.relatedAudienceProcesses);

  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (form.deletedAttachments !== undefined) {
    form.deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.incidentNumberId) {
    formData.append('incidentNumberId', form.incidentNumberId);
  }

  if (form.outcomeNumberId) {
    formData.append('outcomeNumberId', form.outcomeNumberId);
  }

  if (form.observationTaskNumber) {
    formData.append('observationTaskNumber', form.observationTaskNumber);
  }

  if (form.observationTaskName) {
    formData.append('observationTaskName', form.observationTaskName);
  }

  if (form.relatedAudienceEntities) {
    form.relatedAudienceEntities.forEach((e) => formData.append('relatedAudienceEntities', e as any as string));
    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.relatedAudienceProcesses) {
    form.relatedAudienceProcesses.forEach((e) => formData.append('relatedAudienceProcesses', e as any as string));

    // formData.append('relatedAudienceProcesses', processesData);
  }

  if (form.observers) {
    form.observers.forEach((e) => formData.append('observers', e as any as string));
    // formData.append('relatedAudienceEntities', entitiesData);
  }

  if (form.observerId) {
    formData.append('observerId', form.observerId);
  }

  if (form.description) {
    formData.append('description', form.description);
  }

  if (form.coordinationRemarks) {
    formData.append('coordinationRemarks', form.coordinationRemarks);
  } else {
    formData.append('coordinationRemarks', '');
  }

  if (form.weightOfObservationInOutcome) {
    formData.append('weightOfObservationInOutcome', form.weightOfObservationInOutcome.toString());
  }

  if (form.trainingAudiencePerformance != undefined) {
    formData.append('trainingAudiencePerformance', form.trainingAudiencePerformance.toString());
  }

  if (form.log) {
    formData.append('log', form.log);
  }

  if (form.observation) {
    formData.append('observation', form.observation);
  } else {
    formData.append('observation', '');
  }

  if (form.observationStatusId) {
    formData.append('observationStatusId', form.observationStatusId);
  }
  return axios.patch(urlsConfig.observationTask.observationTaskEdit, formData, { blockErrorHandler: true });
};

export const observationTaskDelete = ({
  id,
}: serviceObservationTaskTypes.ObservationTaskDeleteDataType): AxiosPromise<serviceObservationTaskTypes.ObservationTaskDeleteResultType> => {
  return axios.delete(`${urlsConfig.observationTask.observationTaskDelete}/${id}`);
};
